import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTaskForm as getTaskFormAction } from 'bpm/task-form/actions';
import { RootState } from 'reducers/rootReducer';

const useFetchTaskForm = (taskId: string) => {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(getTaskFormAction(taskId));
    }, [taskId, dispatch]);
    const formFetchStatus = useSelector((state: RootState) => state.taskFormStatuses[taskId]);
    return formFetchStatus;
};
export default useFetchTaskForm;
